/**
 * Photo gallery: main image slider + thumbnail strip + lightbox modal
 */
(function () {
  function openLightbox(container, link, modalRef) {
    const templateEl = container.querySelector('.js-photo-gallery-zoom-template');
    if (!templateEl || !templateEl.content) return;

    let modal = modalRef.current;
    if (!modal || !modal.parentNode) {
      modal = templateEl.content.firstElementChild.cloneNode(true);
      document.body.appendChild(modal);
      modalRef.current = modal;
    }

    const viewer = modal.querySelector('gallery-viewer');
    if (viewer && typeof viewer.init === 'function') {
      const zoomUrl = link.getAttribute('href') || (link.dataset && link.dataset.zoomUrl);
      viewer.init(zoomUrl);
      viewer.focus();
    }

    if (typeof modal.open === 'function') {
      modal.open(link);
    } else {
      modal.setAttribute('open', '');
    }
  }

  function initPhotoGallery(container) {
    const gallery = container.querySelector('[data-photo-gallery]');
    if (!gallery) return;

    const modalRef = { current: null };

    const mainSlides = gallery.querySelectorAll('.photo-gallery__main-slide');
    const thumbs = gallery.querySelectorAll('.photo-gallery__thumb');
    const thumbsContainer = gallery.querySelector('[data-photo-gallery-thumbs]');
    const prevBtn = gallery.querySelector('.photo-gallery__nav--prev');
    const nextBtn = gallery.querySelector('.photo-gallery__nav--next');
    const zoomLinks = gallery.querySelectorAll('.photo-gallery__main .photo-gallery__zoom');

    if (mainSlides.length >= 2) {
      let currentIndex = 0;

      function scrollActiveThumbIntoView() {
        const activeThumb = thumbs[currentIndex];
        if (!activeThumb || !thumbsContainer) return;

        activeThumb.scrollIntoView({
          behavior: 'smooth',
          block: 'nearest',
          inline: 'center'
        });
      }

      function setActive(index) {
        currentIndex = (index + mainSlides.length) % mainSlides.length;

        mainSlides.forEach((slide, i) => {
          slide.classList.toggle('is-active', i === currentIndex);
        });
        thumbs.forEach((thumb, i) => {
          const isActive = i === currentIndex;
          thumb.classList.toggle('is-active', isActive);
          thumb.setAttribute('aria-current', isActive ? 'true' : 'false');
        });

        if (prevBtn) prevBtn.disabled = currentIndex === 0;
        if (nextBtn) nextBtn.disabled = currentIndex === mainSlides.length - 1;

        scrollActiveThumbIntoView();
      }

      if (prevBtn) prevBtn.addEventListener('click', () => setActive(currentIndex - 1));
      if (nextBtn) nextBtn.addEventListener('click', () => setActive(currentIndex + 1));

      thumbs.forEach((thumb, i) => {
        thumb.addEventListener('click', () => setActive(i));
      });

      setActive(0);
    }

    zoomLinks.forEach((link) => {
      link.addEventListener('click', (evt) => {
        evt.preventDefault();
        evt.stopPropagation();
        openLightbox(container, link, modalRef);
      }, true);
    });
  }

  function init() {
    document.querySelectorAll('.photo-gallery-section').forEach(initPhotoGallery);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', (evt) => {
    const section = evt.target.querySelector('.photo-gallery-section');
    if (section) initPhotoGallery(section);
  });
})();
